/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMcpServerAuthenticationSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetMcpServerAuthenticationRequest = {
  /**
   * The MCP server id.
   */
  mcpServerId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetMcpServerAuthenticationSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetMcpServerAuthenticationSecurity$outboundSchema: z.ZodMiniType<
  GetMcpServerAuthenticationSecurity$Outbound,
  GetMcpServerAuthenticationSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function getMcpServerAuthenticationSecurityToJSON(
  getMcpServerAuthenticationSecurity: GetMcpServerAuthenticationSecurity,
): string {
  return JSON.stringify(
    GetMcpServerAuthenticationSecurity$outboundSchema.parse(
      getMcpServerAuthenticationSecurity,
    ),
  );
}

/** @internal */
export type GetMcpServerAuthenticationRequest$Outbound = {
  mcp_server_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetMcpServerAuthenticationRequest$outboundSchema: z.ZodMiniType<
  GetMcpServerAuthenticationRequest$Outbound,
  GetMcpServerAuthenticationRequest
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function getMcpServerAuthenticationRequestToJSON(
  getMcpServerAuthenticationRequest: GetMcpServerAuthenticationRequest,
): string {
  return JSON.stringify(
    GetMcpServerAuthenticationRequest$outboundSchema.parse(
      getMcpServerAuthenticationRequest,
    ),
  );
}
